export default "__VITE_ASSET__e01481b2__"